import styled from 'styled-components';
import {
  FlexContainer,
  Notification as Notification_,
  Text,
  Informative as Informative_,
} from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { Lottie } from 'Components/UI';
import { DESKTOP_EXTRA_SMALL_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.grad_500};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  border-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    > div:first-child {
      order: 2;
    }
  }
`;
export const TitleContainer = styled(Text)`
  width: 100%;
  height: ${({ theme: { spacing } }) => spacing.spacing_40};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: none;
  }
`;

export const Box = styled(FlexContainer)`
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  width: 100%;
  margin: 0 auto;
  max-width: 342px;
  padding: ${({ theme: { spacing } }) => spacing.spacing_24};
  span {
    font-weight: bold;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Notification = styled(Notification_)`
  width: 342px;
  max-width: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Title = styled(Text)`
  display: none;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: block;
  }
`;

export const ContainerInProgress = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.grad_500};
  justify-content: center;
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  border-radius: ${({ theme: { spacing } }) => spacing.spacing_16};
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { spacing } }) => `${spacing.spacing_16} ${spacing.spacing_08}`};
  }
`;

export const DescriptionContainer = styled(FlexContainer)`
  align-items: center;
  justify-content: center;
  width: 400px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Informative = styled(Informative_)`
  width: 400px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const LoaderContainer = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.white};
  border-radius: ${({ theme: { reference } }) => reference.dimension_16};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  width: 358px;
  height: 246px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  }
`;

export const ProgressBarContent = styled.div`
  width: 70%;
`;

export const LottieContainer = styled(Lottie)`
  width: 90%;
`;
